import React from 'react';
import cn from 'bem-cn';

import wreathPaper from '../../../images/icons/wreath_paper.svg';

import { ImageWithFadeIn } from '../ImageWithFadeIn';
import { ScoreBadge } from '../ScoreBadge';

import { AvatarWithRatingProps } from './AvatarWithRating.types';
import './AvatarWithRating.scss';

const b = cn('avatar-with-rating');

export const AvatarWithRating: React.FC<AvatarWithRatingProps> = ({
    avatarSrc,
    size,
    hideScore = false,
    score,
    isScoreLoading,
    scoreError,
}) => {
    // const [wreathMaterial, setWreathMaterial] = useState<WreathMaterial>('paper');

    // useEffect(() => {
    //     if (place < 4) {
    //         setWreathMaterial(
    //             {
    //                 '1': 'gold',
    //                 '2': 'silver',
    //                 '3': 'bronze',
    //             }[place] as WreathMaterial,
    //         );
    //     }

    //     setWreathMaterial('paper');
    // }, [place]);

    if (!avatarSrc) {
        return null;
    }

    return (
        <div className={b({ size })}>
            <img src={avatarSrc} alt="Аватар" className={b('image')} />
            <ImageWithFadeIn src={wreathPaper} alt="" className={b('wreath')} />
            {!hideScore && !scoreError && (
                <ScoreBadge size={size} score={score} isLoading={isScoreLoading} showPrefix={size === 'large'} />
            )}
        </div>
    );
};
